import React from 'react';
import PropTypes from 'prop-types';
import { Navigate, useLocation, Outlet } from 'react-router-dom';

import Error from './Error/Error';

const PlainProtectedRoute = (props) => {
  const location = useLocation();
  const { isAuthenticated, isExpert } = props;

  if (!isAuthenticated) {
    return <Navigate to="/login" state={location} />;
  }

  return isExpert ? (
    <Outlet location />
  ) : (
    <Error errorMessage="You are not authorized to view this page!" />
  )
};

PlainProtectedRoute.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  isExpert: PropTypes.bool.isRequired
};

export default PlainProtectedRoute;
